export const SERVER_API_URL = 'https://www.marinedimelendugno.it/backend';
